import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "../../../constants";

import ViewContent from "./ViewContent";

export default function ViewContentDetails() {
    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.VIEW_CONTENT_LIBRARY_ITEM}</title>
            </Helmet>
            <Container fluid className="customer-details">
                <ViewContent />
            </Container>
        </div>
    );
}
